import {useIgnoreOnboarding} from "@mytour/platform";
import {LetsGo, NoButton} from "@mytour/ui/form";
import {SplitterButtons} from "@mytour/ui/layout";
import {useNavigate} from "react-router";
import {ModalContent, ModalContentWrapper} from "../../ModalContent";

export function EndingAssistant() {
  const navigate = useNavigate();
  const {ignoreOnboarding, isIgnoringOnboarding} = useIgnoreOnboarding();

  return (
    <ModalContentWrapper>
      <ModalContent>
        <h2 style={{marginTop: "8px"}} className="title-custom-style">
          {`C'est terminé !`}
        </h2>
        <p>
          <p>{"Bravo 👏"}</p>
          <p>{`Nous allons maintenant ouvrir l'agenda pour créer des rendez-vous !`}</p>
        </p>
      </ModalContent>
      <SplitterButtons>
        <NoButton
          onClick={handleNo}
          disabled={isIgnoringOnboarding}
          pending={isIgnoringOnboarding}
        />
        <LetsGo onClick={handleLetsGo} disabled={isIgnoringOnboarding} />
      </SplitterButtons>
    </ModalContentWrapper>
  );

  async function handleNo() {
    await ignoreOnboarding();
  }

  async function handleLetsGo() {
    await ignoreOnboarding();
    navigate("/planning");
  }
}
